const DB_NAME = 'coop_finance_kyc'
const STORE_NAME = 'kyc_data'
const DB_VERSION = 1

interface StoredFile {
  buffer: ArrayBuffer
  name: string
  type: string
}

export interface KycStepOneData {
  idtype: string
  idnumero: string
  selfie?: StoredFile
  idphoto?: StoredFile
  idphoto2?: StoredFile
}

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export function fileToStorable(file: File): Promise<StoredFile> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      resolve({ buffer: reader.result as ArrayBuffer, name: file.name, type: file.type })
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(file)
  })
}

export function storedToFile(stored: StoredFile, fieldName: string): File {
  return new File([stored.buffer], stored.name || fieldName, { type: stored.type })
}

export async function saveKycData(data: KycStepOneData): Promise<void> {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    tx.objectStore(STORE_NAME).put(data, 'pending_kyc')
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })
}

export async function getKycData(): Promise<KycStepOneData | null> {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const request = tx.objectStore(STORE_NAME).get('pending_kyc')
    request.onsuccess = () => resolve(request.result ?? null)
    request.onerror = () => reject(request.error)
  })
}

export async function clearKycData(): Promise<void> {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    tx.objectStore(STORE_NAME).delete('pending_kyc')
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })
}
